import { useContext, useEffect, useState } from "react";
import { domainUrl } from "../utils/constant";
import { ContextProvider } from "../../App";

const useCarouselData = () => {
  const [carouselData, setCarouselData] = useState();
  const { setShowLoader } = useContext(ContextProvider);

  useEffect(() => {
    GetCarouselData();
  }, []);

  async function GetCarouselData() {
    try {
      setShowLoader(true);
      const response = await fetch(`${domainUrl}/getCarousels/`);
      if (response.status !== 200) {
        throw new Error("API Internal Error");
      } else {
        const json = await response.json();
        // console.log(json)
        setCarouselData(json?.data[0]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setShowLoader(false);
    }
  }
  return [carouselData];
};

export default useCarouselData;
